// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"c2df51ed","81":"0e004632","223":"15799a70","325":"7600e933","682":"34c66292","905":"004541b1","967":"9acdab06"}[chunkId] + ".chunk.js";
};